var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('s-notification-list'),_vm._v(" "),_c('div',{staticClass:"outer"},[(!_vm.isLoginPage)?_c('NavigationSide',{staticClass:"navigation"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main"},[_c('nuxt')],1)],1),_vm._v(" "),(!_vm.isLoginPage)?_c('sticky-timer'):_vm._e(),_vm._v(" "),_c('slideout-panel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }